import {useEffect, useState} from 'react';

/**
 * Fetches the API version and build date from /api/version/json once on mount.
 * Returns null until the data is available.
 */
export function useAppVersion() {
    const [info, setInfo] = useState(null);
    useEffect(() => {
        fetch('/api/version/json')
            .then(r => r.ok ? r.json() : null)
            .then(data => { if (data) setInfo(data); })
            .catch(() => {});
    }, []);
    return info;
}
